import { Avatar as AntdAvatar } from 'antd'
import styled from 'styled-components'

export const ScanReportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background);
  border-radius: 4px;
  padding-top: 23px;
`

export const LoadingContainer = styled.div`
  height: 576px !important;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ErrorContainer = styled.div`
  height: 528px !important;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Container: any = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  padding-top: 20px;
  padding-bottom: 14px;
  position: relative;
`

export const LeftBar = styled.div`
  position: relative;
  border-bottom: 25px solid #007f7c;
  border-left: 25px solid transparent;
  background-color: transparent;
`

export const LeftBarText = styled.div`
  position: absolute;
  top: 7px;
  left: 0px;
  font-weight: 700;
  font-size: 12px;
  background-color: none;
`

export const LeftBarContainer = styled.div`
  display: flex;
  position: absolute;
  right: 0px;
  z-index: 1;
  margin-top: -2px;
`

export const RightBarContainer = styled.div`
  display: flex;
  position: absolute;
  left: 0px;
  z-index: 1;
  margin-top: -2px;
`

export const RightBar = styled.div`
  position: relative;
  border-bottom: 25px solid #007f7c;
  border-right: 25px solid transparent;
  background-color: transparent;
`

export const RightBarText = styled.div`
  position: absolute;
  top: 7px;
  right: 0px;
  font-weight: 700;
  font-size: 12px;
  background-color: none;
`

export const HexagonContainer = styled.div`
  position: absolute;
  margin: 0px -64.5px 2.5px -64.5px;
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

export const Hexagon = styled.div`
  width: 32px;
  height: 32px;
  position: absolute;
  right: -80px;
  background: var(--color-border-primary);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    background: #ffffff;
    clip-path: inherit;
  }
`

export const HexagonLabel = styled.div`
  z-index: 2;
  text-transform: capitalize;
  font-size: 10px;
  font-weight: bold;
  color: var(--color-text-primary);
`

export const LeftCircle = styled.div`
  background: #d9d5d2;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-top: 10px;
`

export const RightCircle = styled.div`
  background: #d9d5d2;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin-top: 10px;
`

export const Wrapper = styled.div`
  width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 14px;
`

export const Card = styled.div`
  width: 100%;
  height: 80px;
  background: var(--color-background);
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 9px;
  box-shadow: var(--shadow-box);
`

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 700;
`

export const Subtitle = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 400;
  margin-top: 2px;
`

export const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`

export const NavButton = styled.button`
  width: 152px;
  @media (min-width: 1370px) {
    width: 48%;
  }
  height: 52px;
  background: var(--color-background);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: var(--shadow-box);
  transition: 0.2s;

  &:hover {
    background: var(--color-background);
  }
`

export const Score = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 33px;
  min-width: 73px;
  font-weight: 700;
  font-size: 24px;
  border-radius: 4px;
  padding-left: 26px;
`

export const DoctorProfile = styled(AntdAvatar)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
  overflow: hidden;
  border: 1px solid var(--color-border-primary);
`
